import React from 'react';
import { CSPReviews, CSPReviewFragment } from './csp_reviews';

import { ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import { getOffsetFromPage } from '../pagination_helpers';
import { withRouter, WithRouterProps } from 'react-router';

import {
  CoreCspReviews,
} from '../schemas/rql';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface IExternalProps {
  title?: string;
  page?: number;
}

type IProps = WithRouterProps & ChildProps<IExternalProps, CoreCspReviews.Query>;

export function CSP2CSPReviews(props: IProps) {
  if (!props.data.csp) { return null; }
  if (!props.data.csp.reviews) { return null; }

  return (
    <CSPReviews
      csp={props.data.csp}
      offset={getOffsetFromPage(props.location.query.review_page, REVIEWS_LIMIT)}
      refetch={props.data.refetch}
      trackingDisplayStyle="csp"
    />
  );
}

const REVIEWS_LIMIT = 5;

const withQuery = withGraphql<IProps, CoreCspReviews.Query>(
  gql`
    query Core_Csp_Reviews(
      $limit: Int
      $slug: String
      $offset: Int
    ) {
      csp(
        input: {slug: $slug}
      ) {
        _id
        ...CSPReviewCSP
        reviews(input: {limit: $limit, offset: $offset}) {
          ...CSPReviews
        }
      }
    }
    ${CSPReviewFragment}
  `,
  {
    options: (ownProps) => {
      return {
        // allows for partial failures in RQL response
        errorPolicy: 'all',
        ssr: false,
        variables: {
          slug: ownProps.params.slug,
          limit: REVIEWS_LIMIT,
          offset: getOffsetFromPage(ownProps.location.query.review_page, REVIEWS_LIMIT),
        },
      };
    },
  },
);

export default withRouter(withQuery(CSP2CSPReviews));
